import { c as _c } from "react/compiler-runtime";
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useOnEnterOrSpacebar from 'hooks/useOnEnterOrSpacebar';
import ActiveFabricSummary from 'components/consumer/ActiveFabricSummary';
import Badge from 'components/consumer/Badge';
import BrandTooltip from 'components/consumer/BrandTooltip';
import InfoIcon from 'components/icons/IconInfoNew';
import { colorGrayLight2 } from 'styles/layout/colors';
import Placeholder from 'components/consumer/Placeholder';
import usePDPClearanceData from 'data-hooks/useClearanceData/usePDPClearanceData';
import usePDPBasicDetails from '../state/context/usePDPBasicDetails';
const hasBothWords = (str, firstWord, secondWord) => {
  if (!str) {
    return false;
  }
  const strLowerCase = str.toLowerCase();
  return strLowerCase.includes(firstWord) && strLowerCase.includes(secondWord);
};
const getStockQuantityToShow = (selectedOptionsStockQty, isDiningChair) => {
  if (selectedOptionsStockQty <= 5) {
    return selectedOptionsStockQty;
  }
  if (isDiningChair && selectedOptionsStockQty >= 12) {
    return 12;
  }
  return 5;
};
const PDPActiveFabric = t0 => {
  const $ = _c(24);
  const {
    isEditOrder: t1,
    isModularBundleProduct,
    isSelectedOptionsQuickship,
    loading,
    onClick,
    selectedOption,
    selectedOptionsStockQty,
    showAdditionalCost: t2,
    showInfoIcon: t3,
    showThumbnail: t4,
    size: t5,
    materialNameClass: t6,
    fullHeight: t7,
    className: t8
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const showAdditionalCost = t2 === undefined ? true : t2;
  const showInfoIcon = t3 === undefined ? true : t3;
  const showThumbnail = t4 === undefined ? true : t4;
  const size = t5 === undefined ? "md" : t5;
  const materialNameClass = t6 === undefined ? "" : t6;
  const fullHeight = t7 === undefined ? false : t7;
  const className = t8 === undefined ? "" : t8;
  const {
    data: basicDetailsData
  } = usePDPBasicDetails();
  const {
    type
  } = basicDetailsData ?? {};
  const isDiningChair = hasBothWords(type?.name, "dining", "chair");
  const {
    data: t9
  } = usePDPClearanceData();
  const {
    isClearance,
    isFlashSale
  } = t9;
  const activeFabricRef = useRef(null);
  useOnEnterOrSpacebar(!!onClick, activeFabricRef, onClick);
  const showFinalSale = !isFlashSale && isClearance;
  if (loading) {
    let t10;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <div className="flex justify-start"><Placeholder type="rect" loading={true} className="mb-2 lg:mb-1.5" style={{
          height: "23px",
          width: "175px"
        }} /></div>;
      $[0] = t10;
    } else {
      t10 = $[0];
    }
    return t10;
  }
  if (!selectedOption) {
    return null;
  }
  const label = `More information about ${selectedOption.label || selectedOption.value}`;
  const formattedAddlCost = _temp;
  const T0 = ActiveFabricSummary;
  const t10 = "PDPActiveFabric-name";
  const t11 = "PDPActiveFabricInfoButton";
  const t12 = onClick && "focus-visible:border-brand focus-visible:border-radius-2xl focus-visible:rounded focus-visible:outline-none";
  let t13;
  if ($[1] !== className || $[2] !== t12) {
    t13 = classNames("border-2 border-solid border-transparent", t12, className);
    $[1] = className;
    $[2] = t12;
    $[3] = t13;
  } else {
    t13 = $[3];
  }
  const t14 = onClick ? "button" : undefined;
  const t15 = onClick ? "0" : undefined;
  const t16 = onClick ? label : undefined;
  const t17 = selectedOption?.additionalCost && showAdditionalCost ? <span className={classNames("font-bold flex items-center", {
    "text-xs": size === "xs",
    "text-sm": size === "sm",
    "text-base": size === "md"
  })}>{"  ("}{isEditOrder && selectedOption?.origAddlCost && selectedOption.origAddlCost !== selectedOption.additionalCost && <span className="line-through text-xs px-0.5">{formattedAddlCost(selectedOption?.origAddlCost)}</span>}<span className={classNames("font-bold text-xs", {
      "text-red": isEditOrder
    })}>{formattedAddlCost(selectedOption?.additionalCost)}{isModularBundleProduct ? "/piece" : ""}</span>)</span> : isSelectedOptionsQuickship && selectedOptionsStockQty ? <span className="text-red text-xs font-bold ml-1.5"><span className="mr-1.5">•</span><span>{`Only ${getStockQuantityToShow(selectedOptionsStockQty, isDiningChair)} left!`}</span></span> : null;
  let t18;
  if ($[4] !== showInfoIcon) {
    t18 = showInfoIcon && <> <InfoIcon className="cursor-pointer" color={colorGrayLight2} height={13} width={13} aria-hidden="true" /></>;
    $[4] = showInfoIcon;
    $[5] = t18;
  } else {
    t18 = $[5];
  }
  let t19;
  if ($[6] !== showFinalSale) {
    t19 = showFinalSale && <BrandTooltip inactiveOnMobile={true} showInfoIcon={false} customIcon={<Badge className="w-fit bg-yellow-light px-2"><span className="text-gray">Final Sale</span></Badge>} arrowOffset={32}>{"This final sale product is eligible for cancellation within 24 hours of order placement. Ineligible for returns except for items arriving damaged & documented by carrier. Ineligible for warranty claims unless reports of defects are submitted within 14 days of delivery, cosmetic damage isn't covered."}</BrandTooltip>;
    $[6] = showFinalSale;
    $[7] = t19;
  } else {
    t19 = $[7];
  }
  let t20;
  if ($[8] !== T0 || $[9] !== fullHeight || $[10] !== label || $[11] !== materialNameClass || $[12] !== onClick || $[13] !== selectedOption || $[14] !== showThumbnail || $[15] !== size || $[16] !== t13 || $[17] !== t14 || $[18] !== t15 || $[19] !== t16 || $[20] !== t17 || $[21] !== t18 || $[22] !== t19) {
    t20 = <T0 ref={activeFabricRef} selectedOption={selectedOption} size={size} materialNameClass={materialNameClass} fullHeight={fullHeight} showThumbnail={showThumbnail} nameDataXc={t10} rowDataXc={t11} className={t13} onClick={onClick} role={t14} tabIndex={t15} ariaLabel={t16} title={label}>{t17}{t18}{t19}</T0>;
    $[8] = T0;
    $[9] = fullHeight;
    $[10] = label;
    $[11] = materialNameClass;
    $[12] = onClick;
    $[13] = selectedOption;
    $[14] = showThumbnail;
    $[15] = size;
    $[16] = t13;
    $[17] = t14;
    $[18] = t15;
    $[19] = t16;
    $[20] = t17;
    $[21] = t18;
    $[22] = t19;
    $[23] = t20;
  } else {
    t20 = $[23];
  }
  return t20;
};
PDPActiveFabric.propTypes = {
  isEditOrder: PropTypes.bool,
  isModularBundleProduct: PropTypes.bool,
  isSelectedOptionsQuickship: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['xs', 'sm', 'md']),
  selectedOption: PropTypes.shape({
    exclude_from_sale: PropTypes.bool,
    additionalCost: PropTypes.number,
    description: PropTypes.string,
    image: PropTypes.string,
    label: PropTypes.string,
    materialId: PropTypes.number,
    origAddlCost: PropTypes.number,
    upholsteryOptionId: PropTypes.number,
    value: PropTypes.string,
    sku: PropTypes.string
  }),
  selectedOptionsStockQty: PropTypes.number,
  showAdditionalCost: PropTypes.bool,
  showInfoIcon: PropTypes.bool,
  showThumbnail: PropTypes.bool,
  materialNameClass: PropTypes.string,
  fullHeight: PropTypes.bool,
  className: PropTypes.string
};
export default PDPActiveFabric;
function _temp(cost) {
  return cost < 0 ? `-$${cost * -1}` : `$${cost}`;
}